import { Tag } from '@cian/components';
import * as React from 'react';

import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface ILoggiaTagItemProps {
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const LoggiaTagItem = ({ onDeleteClick, withNewTag }: ILoggiaTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Есть лоджия
    </TagComponent>
  );
};
